import { render, staticRenderFns } from "./CampaignTemplateEmailPreview.vue?vue&type=template&id=805c5724&scoped=true&"
import script from "./CampaignTemplateEmailPreview.vue?vue&type=script&lang=js&"
export * from "./CampaignTemplateEmailPreview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTemplateEmailPreview.vue?vue&type=style&index=0&id=805c5724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805c5724",
  null
  
)

export default component.exports